<template>
    <div v-if="zona" class="mt-2">
        <div class="container-butacas-wrapper" v-if="!loading">
            <div :class="'container-butacas text-align-' + zona.print_align">
                <template v-if="zona?.with_seats && filas">
                    <template v-for="(butacas, fila) in filas">
                        <span :key="fila">
                            <span class="fila">{{ fila }}</span>
                            <template v-for="(asiento, index) in butacas">
                                <AsientoComponent 
                                    :asiento="asiento" 
                                    :fila="fila" 
                                    :key="index" 
                                    @toggle="() => toggleSeleccion(fila, asiento.asiento, asiento.ocupado)"
                                />
                            </template>
                            <br />
                        </span>
                    </template>
                </template>
            </div>
        </div>
        <div v-else style="margin-top: 150px;">
            <LoaderComponent />
        </div>
    </div>
</template>

<script>
    import AsientoComponent from "@/components/backend/stepper/components/AsientoComponent";

    export default {
        props: {
            loading: {
                type: Boolean,
                defualt: false
            },
            zona: {
                type: Object
            }
        },
        data() {
            return {
                filas: null
            }
        },
        methods: {
            getAsientos() {
                if(!this.zona.with_seats) {
                    this.toggleSeleccion(0, 0, 0);
                } else {
                    this.$emit('update:loading', true);

                    let params = {
                        filters: {
                            zona_id: this.zona.id,
                            conf: true
                        }
                    };

                    this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                        this.filas = res.data.configuracion_asientos;
                        this.$emit('update:loading', false);
                    });
                }
            },
            toggleSeleccion(fila, asiento, ocupado) {
                this.$emit('cambiarAsiento', fila, asiento, ocupado);
            }
        },
        watch: {
            zona: {
                handler(newVal) {
                    if (newVal) {
                        this.getAsientos();
                    }
                },
                deep: true
            }
        },
        components: {
            AsientoComponent
        }
    }
</script>